// Which products the shared policy screens serve. Each products/<key> file
// default-exports an adapter (see adapterContract.js) or null while that
// product still uses its old screens. Phase-2 adapters only edit their own
// file: this registry, the routes and the legacy redirects pick them up.
import ad from "./products/ad";
import ssh from "./products/ssh";
import radius from "./products/radius";
import database from "./products/database";
import apps from "./products/apps";
import { POLICY_PRODUCTS, isPolicyProduct } from "./policyProducts";

export const PRODUCT_ADAPTERS = { ad, ssh, radius, database, apps };

/** The adapter for a product key, or null (unknown product, or not moved yet). */
export function getAdapter(product) {
  return isPolicyProduct(product) ? PRODUCT_ADAPTERS[product] || null : null;
}

export const hasAdapter = (product) => !!getAdapter(product);

export { POLICY_PRODUCTS };
